const uuid = "[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}";
const catalogPath = new RegExp(`^/v1/items/${uuid}/assets/${uuid}/captions\\.vtt$`, "i");
const generatedPath = new RegExp(`^/v1/advertising/assets/${uuid}/[1-9]\\d{0,2}/spot\\.vtt$`, "i");

/** Tracks must share the page origin so video playback can remain free of CORS requirements. */
export function safeCaptionTrackUrl(value: string | null | undefined, pageUrl: string): string | null {
  if (!value) return null;
  try {
    const page = new URL(pageUrl);
    const url = new URL(value, page);
    const local = page.protocol === "http:" && ["localhost", "127.0.0.1", "[::1]"].includes(page.hostname);
    if ((!local && page.protocol !== "https:") || url.origin !== page.origin || url.username || url.password || url.search || url.hash) return null;
    return catalogPath.test(url.pathname) || generatedPath.test(url.pathname) ? url.href : null;
  } catch { return null; }
}
